<template>
  <!--
    Komponent wyświetlający filtr pasów ruchu jako tabelę z checkboxami.
    Pozwala użytkownikowi wybrać pojedyncze pasy.
    Klasę CSS 'step-X' można wykorzystać do dostosowania wyglądu w różnych krokach.
  -->
  <div class="lane-numbers" :class="`step-${step}`">
    <!--
      Nagłówek sekcji z przetłumaczoną nazwą 'PASY'.
    -->
    <h3 class="margin-0">{{ t('lanes').toUpperCase() }}</h3>
    <!--
      Tabela prezentująca numery pasów i checkboxy do wyboru.
    -->
    <table class="lane-table">
      <thead>
        <tr>
          <th class="sign">&gt;</th> <!-- Kolumna na ikonę lub znak wskazujący -->
          <!-- Nagłówki kolumn z numerami pasów -->
          <th
            v-for="(item, index) in store.laneNumbers"
            :key="'th-' + index"
          >
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td></td> <!-- Pusta komórka pod kolumną 'sign' -->
          <!-- Checkboxy dla każdego pasa -->
          <td
            v-for="(item, index) in store.laneNumbers"
            :key="'cb-' + index"
          >
            <input-checkbox
              :field-name="index"
              field-value=""
              :checkedCondition="isChecked(index)"
              @clicked="setFilter(index)"
            />
          </td>
        </tr>
      </tbody>
      <!--
        Zakomentowana alternatywna struktura tabeli dla testów.
      -->
      <!-- <thead>
        <tr>
          <th>1</th><th>2</th><th>3</th><th>4</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="(_, i) in 4" :key="i">
            <input-checkbox
              :field-name="i"
              field-value=""
              :checkedCondition="isChecked(i)"
              @clicked="setFilter(i)"
            />
          </td>
        </tr>
      </tbody> -->
    </table>
  </div>
</template>

<script>
import InputCheckbox from "../InputCheckbox.vue"; // Komponent checkbox

export default {
  name: "LaneNumbers", // Nazwa komponentu
  props: {
    store: { required: true }, // Pinia store z danymi filtrów
    step: { type: Number, default: 1 }, // Aktualny krok widoku (do stylowania)
  },
  components: { InputCheckbox },
  methods: {
    /**
     * Dodaje lub usuwa numer pasa w filtrach
     * @param {number} index - indeks wybranego pasa
     */
    setFilter(index) {
      this.store.addItem("LaneNumbers", index);
    },
    /**
     * Sprawdza, czy dany pas jest zaznaczony w filtrach
     * @param {number} id - indeks pasa
     * @returns {boolean}
     */
    isChecked(id) {
      return (
        this.store.filters.laneNumbers &&
        this.store.filters.laneNumbers.includes(
          this.store.laneNumbers[id]
        )
      );
    },
  },
};
</script>

<style scoped>
.lane-numbers.step-1 {
  width: 172px;
  /* min-height: 140px; */
}

.lane-numbers.step-2 {
  width: 230px;
  border-bottom: 1px solid #bfbfbf;
  /* min-height: 140px; */
}

.lane-numbers.step-1 h3 {
  /* padding: 10px 15px 10px 30px; */
  padding: 0.85rem 1rem 0.9rem 1rem;
  width: 100%;
  margin: 0;
  border-bottom: 1px solid #bfbfbf;
  border-top: 1px solid #bfbfbf;
}

.lane-numbers.step-2 h3 {
  /* padding: 10px 15px 10px 30px; */
  padding: 0.85rem 1rem 0.9rem 1rem;
  width: 100%;
  margin: 0;
  border-bottom: 1px solid #bfbfbf;
  border-top: 1px solid #bfbfbf;
}

.lane-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  background-color: white;
  /* min-height: 131px; */
  /* table-layout: fixed; */
}

table thead, table tbody {
  border-right: none;
}

th,
td {
  padding: 0.5rem;
  font-size: 12px;
  text-align: center;     
  vertical-align: middle; 
  height: 43px;   
}

.lane-numbers.step-2 .lane-table th, .lane-numbers.step-2 .lane-table td {
  height: 52px;
}

tr {
  border-bottom: 1px solid #bfbfbf;
}

td .container {
  margin-top: 0.40rem;
  padding: 11.5px;
}

th.sign {
  width: 20px;
  border: none;
}
</style>